import { EssAccountsTypes } from '../types/account';

export const getInitialType = (hasElectricity: boolean, hasGas: boolean, hasRenewables?: boolean): string => {
  if (hasElectricity) return EssAccountsTypes.Electricity;
  else if (hasGas) return EssAccountsTypes.Gas;
  else if (hasRenewables) return EssAccountsTypes.Renewables;
  else return '';
};
